import { Button, Col, Row, Space, Spin } from 'antd';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ReactSVG } from 'react-svg';
import { DATE_BACKEND_FORMAT, ORDER_STATUSES } from '../../constants';
import BreadCrumb from '../../modules/breadcrumbs';
import { selectAllOrders } from '../../modules/orders/store/slice';
import { doGetOrders } from '../../modules/orders/store/thunk';
import { doGetRoutePlanRiders } from '../../modules/route-plans-riders/stores/thunk';
import { doAddOrdersToRoutePlan, doGetRoutePlan } from '../../modules/route-plans/stores/thunk';
import RouteAddOrdersTable from '../Tables/RoutePlans/RouteAddOrdersTable';
import RoutePlanLeft from './RoutePlans/RoutePlanLeft';
import withPage from './withPage';

const PAGE_SIZE = 100;

const RoutePlanAddOrders = ({ query, id }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isFetchingOrder = useSelector((state) => state.order.isFetching);
  const isFetchingRouteRider = useSelector((state) => state.routePlanRider.isFetching);
  const isFetchingRouteOrder = useSelector((state) => state.routePlanOrder.isFetching);
  const metadata = useSelector((state) => state.order.metadata);
  const orders = useSelector((state) => selectAllOrders(state));
  const isFetchingRoutePlan = useSelector((state) => state.routePlan.isFetching);
  const routePlan = useSelector((state) => state.routePlan.routePlanDetail) || {};
  const routePlanRiders = routePlan?.riders || [];
  const routePlanOrders = routePlan?.orders || [];

  const isFetching = isFetchingOrder || isFetchingRoutePlan || isFetchingRouteRider || isFetchingRouteOrder;

  const breadCrumbs = [
    { text: 'ROUTES', url: '/routes' },
    {
      text:
        moment(routePlan?.deliveryDate).utc().format('MMM').toLocaleUpperCase() +
        moment(routePlan?.deliveryDate).utc().format('DD') +
        '-' +
        routePlan?.id,
    },
  ];

  const currentPage = Number(query.currentPage) || 1;
  const itemsPerPage = Number(query.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    total: metadata.totalItems - routePlanOrders?.length,
    showTotal: (total) => `${total} Orders`,
  };

  useEffect(() => {
    dispatch(doGetRoutePlanRiders({ id }));
    dispatch(doGetRoutePlan({ id }));
  }, []);

  useEffect(() => {
    if (routePlan?.deliveryDate) {
      dispatch(
        doGetOrders({
          deliveryDate: moment(routePlan.deliveryDate).format(DATE_BACKEND_FORMAT),
          status: ORDER_STATUSES.DRAFT,
          routeRegion: routePlan?.region || '',
          roleType: 'carrier',
        }),
      );
    }
  }, [routePlan]);

  const handleAddOrders = async (selectedOrders) => {
    await dispatch(
      doAddOrdersToRoutePlan({
        id: routePlan.slug,
        orders: selectedOrders.map((o) => Number(o.id)),
      }),
    );
    dispatch(doGetRoutePlanRiders({ id }));
    const url =
      routePlanRiders.length > 0 ? `/routes/${routePlan.slug}/orders` : `/routes/${routePlan.slug}/add-riders`;
    history.push(url);
  };

  const handleBulkUpdate = (selectedOrders) => {
    return {
      title: `${selectedOrders.length} Orders selected`,
      actions: (
        <Space>
          <Button
            className="btn-add-to-route"
            size="large"
            key="AddToRoute"
            type="primary"
            disabled={selectedOrders.length <= 0}
            onClick={() => handleAddOrders(selectedOrders)}
          >
            Add to Route
            <ReactSVG className="icon" src="/icons/add-to-route.svg" />
          </Button>
        </Space>
      ),
    };
  };

  if (!routePlan) return <></>;

  return (
    <Spin spinning={isFetching}>
      <div className="RoutePlanContent">
        <div className="ContentLeft">
          <RoutePlanLeft routePlan={routePlan} riders={routePlanRiders} orders={routePlanOrders} />
        </div>
        <div className="Content ContentFull RoutePlanAddRidersPage">
          <div className="wrapper">
            <Row>
              <Col span={24}>
                <div className="ContentMain">
                  <div className="header">
                    <BreadCrumb breadCrumbs={breadCrumbs} />
                  </div>
                  <RouteAddOrdersTable
                    dataSource={filter(
                      orders,
                      (d) =>
                        !includes(
                          routePlanOrders.map((rr) => rr.id),
                          d.id,
                        ),
                    )}
                    pagination={pagination}
                    rowKey="id"
                    isFetching={isFetching}
                    bulkUpdate={handleBulkUpdate}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default withPage(RoutePlanAddOrders);
